import { ApiFactory } from '@/api/api-factory';

const starfishAssistant = ApiFactory.getStarfishAssistant();

export default {
  async ask({ state }, message) {
    const { conversation, gptModel, reasoningLevel } = state;
    if (conversation.messages.length === 0) {
      conversation.addSystemHtmlInstructions();
    }
    conversation.setCurrentGptModel(gptModel, reasoningLevel);
    conversation.addUserMessage(message);
    await starfishAssistant.ask(conversation);
  },

  async summarize({ state }, message) {
    const { 
      summaryConversation,
      shortSummaryConversation, 
      gptModel, 
      reasoningLevel, 
    } = state;
    
    summaryConversation.addSystemHtmlInstructions();
    summaryConversation.setCurrentGptModel(gptModel, reasoningLevel);
    summaryConversation.addSummarizeMessage(message);
    
    shortSummaryConversation.addSystemHtmlInstructions();
    shortSummaryConversation.setCurrentGptModel(gptModel, reasoningLevel);
    shortSummaryConversation.addShortSummarizeMessage(message);
    const result = await starfishAssistant.ask(summaryConversation);
    return result;
  },

  async summarizeBriefly({ state }, message) {
    const { shortSummaryConversation } = state;
    // shortSummaryConversation.addUserMessage(message);
    const result = await starfishAssistant.ask(shortSummaryConversation);
    return result;
  },

  includeSummaryMessage({ state }, message) {
    const { shortSummaryConversation, gptModel, reasoningLevel } = state;
    shortSummaryConversation.addSystemHtmlInstructions();
    shortSummaryConversation.setCurrentGptModel(gptModel, reasoningLevel);
    shortSummaryConversation.addShortSummarizeMessage(message);
  },

  async generateAssetCaseStudy({ state }, message) {
    const { caseStudyConversation, gptModel, reasoningLevel } = state;
    caseStudyConversation.addSystemHtmlInstructions();
    caseStudyConversation.setCurrentGptModel(gptModel, reasoningLevel);
    caseStudyConversation.addCaseStudyMessage(message);
    const result = await starfishAssistant.ask(caseStudyConversation);
    return result;
  },

  async generateCustomCaseStudy({ state }, message) {
    const { customCaseStudyConversation, gptModel, reasoningLevel } = state;
    customCaseStudyConversation.addSystemHtmlInstructions();
    customCaseStudyConversation.setCurrentGptModel(gptModel, reasoningLevel);
    customCaseStudyConversation.addCustomCaseStudyMessage(message);
    const result = await starfishAssistant.ask(customCaseStudyConversation);
    return result;
  },

  includeContentMessage({ state }, message) {
    const { conversation, gptModel, reasoningLevel } = state;
    conversation.setCurrentGptModel(gptModel, reasoningLevel);
    if (conversation.messages.length === 0) {
      conversation.addSystemHtmlInstructions();
      conversation.addContentMessage(message);
    }
  },

  async extractThemes({ state }, message) {
    const { extractThemesConversation, gptModel, reasoningLevel } = state;
    extractThemesConversation.addSystemHtmlInstructions();
    extractThemesConversation.setCurrentGptModel(gptModel, reasoningLevel);
    extractThemesConversation.addExtractThemesMessage(message);
    const result = await starfishAssistant.ask(extractThemesConversation);
    return result;
  },

  async extractTone({ state }, message) {
    const { extractToneConversation, gptModel, reasoningLevel } = state;
    extractToneConversation.addSystemHtmlInstructions();
    extractToneConversation.setCurrentGptModel(gptModel, reasoningLevel);
    extractToneConversation.addExtractToneMessage(message);
    const result = await starfishAssistant.ask(extractToneConversation);
    return result;
  },

  async generateNewsLetterSummary({ state }, message) {
    const { newsletterConversation, gptModel, reasoningLevel } = state;
    newsletterConversation.addSystemHtmlInstructions();
    newsletterConversation.setCurrentGptModel(gptModel, reasoningLevel);
    newsletterConversation.addNewsLetterMessage(message);
    const result = await starfishAssistant.ask(newsletterConversation);
    return result;
  },

  async generateCustomNewsletterCopy({ state }, message) {
    const { customNewsletterConversation, gptModel, reasoningLevel } = state;
    customNewsletterConversation.addSystemHtmlInstructions();
    customNewsletterConversation.setCurrentGptModel(gptModel, reasoningLevel);
    customNewsletterConversation.addCustomNewsLetterMessage(message);
    const result = await starfishAssistant.ask(customNewsletterConversation);
    return result;
  },

  async generateSlidePresentation({ state }, message) {
    const { slidePresentationConversation, gptModel, reasoningLevel } = state;
    slidePresentationConversation.addSystemHtmlInstructions();
    slidePresentationConversation.setCurrentGptModel(gptModel, reasoningLevel);
    slidePresentationConversation.addSlidePresentationMessage(message);
    const result = await starfishAssistant.ask(slidePresentationConversation);
    return result;
  },

  async generateCustomPresentationSlide({ state }, message) {
    const { customPresentationSlideConversation, gptModel, reasoningLevel } = state;
    customPresentationSlideConversation.addSystemHtmlInstructions();
    customPresentationSlideConversation.setCurrentGptModel(gptModel, reasoningLevel);
    customPresentationSlideConversation.addCustomPresentationSlideMessage(message);
    const result = await starfishAssistant.ask(customPresentationSlideConversation);
    return result;
  },

  async generateSocialPostSummary({ state }, message) {
    const { socialpostConversation, gptModel, reasoningLevel } = state;
    socialpostConversation.addSystemHtmlInstructions();
    socialpostConversation.setCurrentGptModel(gptModel, reasoningLevel);
    socialpostConversation.addSocialPostMessage(message);
    const result = await starfishAssistant.ask(socialpostConversation);
    return result;
  },

  async generateCustomSocialPostCopy({ state }, message) {
    const { customSocialpostConversation, gptModel, reasoningLevel } = state;
    customSocialpostConversation.addSystemHtmlInstructions();
    customSocialpostConversation.setCurrentGptModel(gptModel, reasoningLevel);
    customSocialpostConversation.addCustomSocialPostMessage(message);
    const result = await starfishAssistant.ask(customSocialpostConversation);
    return result;
  },

  async generateInsightsSummary({ state }, message) {
    const { insightsConversation, gptModel, reasoningLevel } = state;
    insightsConversation.addSystemHtmlInstructions();
    insightsConversation.setCurrentGptModel(gptModel, reasoningLevel);
    insightsConversation.addInsightsMessage(message);
    const result = await starfishAssistant.ask(insightsConversation);
    return result;
  },

  async continueConversation({ state }, { conversation, message }) {
    const { gptModel, reasoningLevel } = state;
    conversation.setCurrentGptModel(gptModel, reasoningLevel);
    conversation.addUserMessage(message);
    const result = await starfishAssistant.ask(conversation);
    return result;
  },

  async getIndexCollections({ rootState }, type) {
    const { deploymentIndexId } = rootState
      .common.userDeployments.currentDeployment.currentIndex;

    const result = await starfishAssistant.indexCollections({
      type: type,
      siteId: deploymentIndexId,
    });
    return result;
  },

  async askQuestionOnCollection({ state }, { message, userPrompt }) {
    const { responseWriterConversation, gptModel, reasoningLevel } = state;
    responseWriterConversation.addSystemHtmlInstructions();
    responseWriterConversation.setCurrentGptModel(gptModel, reasoningLevel);
    responseWriterConversation.addCollectionQueryMessage(message);
    responseWriterConversation.addUserMessage(userPrompt);
    const result = await starfishAssistant.ask(responseWriterConversation);
    return result;
  },

  async getSuggestions({ state }, conversation) {
    const { gptModel, reasoningLevel } = state;
    conversation.setCurrentGptModel(gptModel, reasoningLevel);
    conversation.addSuggestionsMessage('');
    const result = await starfishAssistant.ask(conversation);
    const lastIndex = conversation.messages.length - 1;
    if (conversation.messages[lastIndex].role === 'assistant') {
      conversation.messages[lastIndex].role = 'assistant_suggestions';
    }
    return conversation;
  },

  initiateImageAnalyzerConversation({ state }, message) {
    const { imageAnalyzerConversation, gptModel, reasoningLevel } = state;
    imageAnalyzerConversation.addSystemHtmlInstructions();
    imageAnalyzerConversation.setCurrentGptModel(gptModel, reasoningLevel);
    imageAnalyzerConversation.addImageAnalyzerMessage(message);
  },

  async analyzeImageData({ state }, message) {
    const { imageAnalyzerConversation } = state;
    imageAnalyzerConversation.addUserMessage(message);
    const result = await starfishAssistant.ask(imageAnalyzerConversation);
    return result;
  },

  initiatePreviewAnalyzerConversation({ state }, message) {
    const { previewAnalyzerConversation, gptModel, reasoningLevel } = state;
    previewAnalyzerConversation.addSystemHtmlInstructions();
    previewAnalyzerConversation.setCurrentGptModel(gptModel, reasoningLevel);
    previewAnalyzerConversation.addImageAnalyzerMessage(message);
  },

  async analyzePreviewData({ state }, message) {
    const { previewAnalyzerConversation } = state;
    previewAnalyzerConversation.addUserMessage(message);
    const result = await starfishAssistant.ask(previewAnalyzerConversation);
    return result;
  },

  initiateImageAltTagConversation({ state }, message) {
    const { imageAltTagConversation, gptModel, reasoningLevel } = state;
    imageAltTagConversation.addSystemHtmlInstructions();
    imageAltTagConversation.setCurrentGptModel(gptModel, reasoningLevel);
    imageAltTagConversation.addImageAnalyzerMessage(message);
  },

  async generateImageAltTag({ state }, message) {
    const { imageAltTagConversation } = state;
    imageAltTagConversation.addUserMessage(message);
    imageAltTagConversation.addUserMessage('Rewrite as Image ALT Tag');
    const result = await starfishAssistant.ask(imageAltTagConversation);
    return result;
  },

  initiateImageCaptionConversation({ state }, message) {
    const { imageCaptionConversation, gptModel, reasoningLevel } = state;
    imageCaptionConversation.addSystemHtmlInstructions();
    imageCaptionConversation.setCurrentGptModel(gptModel, reasoningLevel);
    imageCaptionConversation.addImageAnalyzerMessage(message);
  },

  async generateImageCaption({ state }, message) {
    const { imageCaptionConversation } = state;
    imageCaptionConversation.addUserMessage(message);
    imageCaptionConversation.addUserMessage('Rewrite as an Image caption');
    const result = await starfishAssistant.ask(imageCaptionConversation);
    return result;
  },
  
  async initiateCollectionAssetsConversation({ state, dispatch }, message) {
    const { conversation } = state;
    if (conversation.messages.length === 0) {
      conversation.addSystemHtmlInstructions();
      conversation.addCollectionQueryMessage(message);
    }
    const result = await dispatch('getSuggestions', conversation);
    return result;
  },

  async initiateCollectionInsightsConversation({ state }, message) {
    const { insightsConversation, gptModel, reasoningLevel } = state;
    insightsConversation.addSystemHtmlInstructions();
    insightsConversation.setCurrentGptModel(gptModel, reasoningLevel);
    insightsConversation.addCollectionInsightsSummaryMessage(message);
    const result = await starfishAssistant.ask(insightsConversation);
    return result;
  },

  async summarizeCollectionAssets({ state }, message) {
    const { 
      summaryConversation, 
      shortSummaryConversation,
      gptModel, 
      reasoningLevel,
    } = state;
    summaryConversation.addSystemHtmlInstructions();
    summaryConversation.setCurrentGptModel(gptModel, reasoningLevel);
    summaryConversation.addCollectionAssetsSummaryMessage(message);
    shortSummaryConversation.addSystemHtmlInstructions();
    shortSummaryConversation.setCurrentGptModel(gptModel, reasoningLevel);
    shortSummaryConversation.addCollectionAssetsSummaryMessage(message);
    const result = await starfishAssistant.ask(summaryConversation);
    return result;
  },

  async generateShareMessage({ state }, message) {
    const { shareMessageConversation, gptModel, reasoningLevel } = state;
    shareMessageConversation.setCurrentGptModel(gptModel, reasoningLevel);
    shareMessageConversation.addShareMessage(message);
    const result = await starfishAssistant.ask(shareMessageConversation);
    return result;
  },

  async generateFollowUpShareMessage({ state }, message) {
    const { shareMessageConversation, gptModel, reasoningLevel } = state;
    shareMessageConversation.setCurrentGptModel(gptModel, reasoningLevel);
    shareMessageConversation.addUserMessage(message);
    const result = await starfishAssistant.ask(shareMessageConversation);
    return result;
  },

  initiateShareMessageConversationForAsset({ state }, message) {
    const { shareMessageConversation } = state;
    shareMessageConversation.addSystemHtmlInstructions();
    shareMessageConversation.addContentMessage(message);
  },

  initiateCustomShareMessageConversationForAsset({ state }, message) {
    const { customShareMessageConversation } = state;
    customShareMessageConversation.addSystemHtmlInstructions();
    customShareMessageConversation.addContentMessage(message);
  },

  initiateCustomShareMessageConversationForCollection({ state }, message) {
    const { shareMessageConversation } = state;
    shareMessageConversation.addSystemHtmlInstructions();
    // shareMessageConversation.addCollectionQueryMessage(message);
  },

  async generateCustomShareMessage({ state }, message) {
    const { customShareMessageConversation, gptModel, reasoningLevel } = state;
    customShareMessageConversation.setCurrentGptModel(gptModel, reasoningLevel);
    customShareMessageConversation.addCustomShareMessage(message);
    const result = await starfishAssistant.ask(customShareMessageConversation);
    return result;
  },

  async generateFollowUpCustomShareMessage({ state }, message) {
    const { customShareMessageConversation, gptModel, reasoningLevel } = state;
    customShareMessageConversation.setCurrentGptModel(gptModel, reasoningLevel);
    customShareMessageConversation.addUserMessage(message);
    const result = await starfishAssistant.ask(customShareMessageConversation);
    return result;
  },

  async askRAG({ state }, { message, endpointInfo }) {
    const { ragConversation, ragConversationStream } = state;
    ragConversation.addUserMessage(message);
    ragConversationStream.addQuery(message);
    const result = await starfishAssistant.askRag({
      query: message,
      conversation: ragConversation,
      conversationSteram: ragConversationStream,
      endpointInfo: endpointInfo,
    });
    return result;
  },

  addPromptInstructions({ state }, message = '') {
    const { conversation } = state;
    if (conversation.messages.length === 0) {
      conversation.addSystemHtmlInstructions();
      // conversation.addPromptInstructionsMessage(message);
    }
  },

  resetConversations({ commit }) {
    commit('resetConversation');
    commit('resetSummaryConversation');
    commit('resetCaseStudyConversation');
    commit('resetExtractThemesConversation');
    commit('resetExtractToneConversation');
    commit('resetNewsletterConversation');
    commit('resetSlidePresentationConversation');
    commit('resetSocialpostConversation');
    commit('resetResponseWriterConversation');
    commit('resetImageAnalyzerConversation');
    commit('resetInsightsConversation');
  },

  async analyzeDocumentData({ state }, message) {
    const { documentAnalyzerConversation, gptModel, reasoningLevel } = state;
    documentAnalyzerConversation.addSystemHtmlInstructions();
    documentAnalyzerConversation.setCurrentGptModel(gptModel, reasoningLevel);
    documentAnalyzerConversation.addDocumentAnalyzerMessage(message);
    const result = await starfishAssistant.ask(documentAnalyzerConversation);
    return result;
  },

  updateSelectedGptModel({ commit }, value) {
    commit('setSelectedGptModel', value);
  },

  updateSelectedReasoningLevel({ commit }, value) {
    commit('setSelectedReasoningLevel', value);
  },

  getCurrentInteractMessages(_, currentConversation) {
    const { messages } = currentConversation;
    const ignoredRoles = ['add_system_html_instructions'];
    const firstAssistantIndex = messages.findIndex((msg) => msg.role.startsWith('assistant'));
    const beforeFirstAssistant = firstAssistantIndex === -1
      ? messages
      : messages.slice(0, firstAssistantIndex);

    const filteredMessages = beforeFirstAssistant.filter(
      (msg) => !ignoredRoles.includes(msg.role),
    );

    return filteredMessages;
  },

  getLastUserMessage({ dispatch }, currentConversation) {
    const { messages } = currentConversation;
    const userMessageIndex = messages.length - 3;
    if (messages[userMessageIndex].role === 'user') return [messages[userMessageIndex]];
    return dispatch('getCurrentInteractMessages', currentConversation);
  },

  async getFollowUpMessagesOnModelChange({ dispatch }, { selectedOption, conversation }) {
    if (selectedOption === 'rerun_interact') {
      const messages = await dispatch('getCurrentInteractMessages', conversation);
      return conversation.messages.push(...messages);
    }
    const message = await dispatch('getLastUserMessage', conversation);
    return conversation.messages.push(...message);
  },

  async askOnModelChange({ state }, currentConversation) {
    const { gptModel, reasoningLevel } = state;
    currentConversation.setCurrentGptModel(gptModel, reasoningLevel);
    const result = await starfishAssistant.ask(currentConversation);
    const lastSentMessageRole = currentConversation.messages.length - 2;
    if (currentConversation.messages[lastSentMessageRole].role === 'start_off_suggestions') {
      currentConversation.messages[currentConversation.messages.length - 1].role = 'assistant_suggestions';
    }
    return result;
  },
};
